var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChevronLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6508 19.7593C15.2314 20.1187 14.6001 20.0701 14.2407 19.6508L8.24073 12.6508C7.91973 12.2763 7.91973 11.7237 8.24073 11.3492L14.2407 4.34921C14.6001 3.92988 15.2314 3.88132 15.6508 4.24074C16.0701 4.60016 16.1187 5.23146 15.7592 5.65079L10.3171 12L15.7592 18.3492C16.1187 18.7685 16.0701 19.3998 15.6508 19.7593Z",
    fill: "#040405"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronLeft);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS42NTA4IDE5Ljc1OTNDMTUuMjMxNCAyMC4xMTg3IDE0LjYwMDEgMjAuMDcwMSAxNC4yNDA3IDE5LjY1MDhMOC4yNDA3MyAxMi42NTA4QzcuOTE5NzMgMTIuMjc2MyA3LjkxOTczIDExLjcyMzcgOC4yNDA3MyAxMS4zNDkyTDE0LjI0MDcgNC4zNDkyMUMxNC42MDAxIDMuOTI5ODggMTUuMjMxNCAzLjg4MTMyIDE1LjY1MDggNC4yNDA3NEMxNi4wNzAxIDQuNjAwMTYgMTYuMTE4NyA1LjIzMTQ2IDE1Ljc1OTIgNS42NTA3OUwxMC4zMTcxIDEyTDE1Ljc1OTIgMTguMzQ5MkMxNi4xMTg3IDE4Ljc2ODUgMTYuMDcwMSAxOS4zOTk4IDE1LjY1MDggMTkuNzU5M1oiIGZpbGw9IiMwNDA0MDUiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };